import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cec41f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader" }
const _hoisted_2 = { class: "line" }
const _hoisted_3 = {
  key: 0,
  class: "text"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseProgressBar',
  props: {
    progress: {},
    hideText: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "colored-line",
        style: _normalizeStyle({ width: `${_ctx.progress}%` })
      }, null, 4)
    ]),
    (!_ctx.hideText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Пожалуйста, подождите"))
      : _createCommentVNode("", true)
  ]))
}
}

})